<template>
  <v-app id="inspire" :style="{background: this.$vuetify.theme.themes.light.background}">
    <loading :active.sync="loader.loading" :loader="loader.type" :color="loader.color" :height="loader.size.height" :width="loader.size.width"/>
    <global-header :user="user" :drawer="drawer" :mini="mini" @updated="updateMiniProperty" @comform="comform"/>
    <global-sidebar :user="user" :drawer="drawer" :mini="mini" @comform="comform"/>
    <v-content>
      <v-container fluid>
        <v-row justify="center" dense>
          <v-col>
            <v-breadcrumbs class="pt-1 pb-2" :items="breadcrumbs" divider=">" large>
              <template v-slot:item="props">
                <v-breadcrumbs-item v-if="props.item.to" exact :disabled="props.item.disabled" @click.prevent="comformTo(props.item.to)">
                  <span v-if="props.item.disabled">{{ props.item.text }}</span>
                  <span v-else><a>{{ props.item.text }}</a></span>
                </v-breadcrumbs-item>
                <v-breadcrumbs-item v-else exact :disabled="props.item.disabled" @click.prevent="comform(props.item.href)">
                  <span v-if="props.item.disabled">{{ props.item.text }}</span>
                  <span v-else><a>{{ props.item.text }}</a></span>
                </v-breadcrumbs-item>
              </template>
            </v-breadcrumbs>
            <v-snackbar v-model="notis" :color="color" :timeout="10000" top right absolute>
              <v-icon dark>{{ icon }}</v-icon> {{ message }} <v-btn icon @click="notis = !notis"><v-icon>mdi-close-circle-outline</v-icon></v-btn>
            </v-snackbar>
          </v-col>
        </v-row>
        <v-divider class="pb-2"></v-divider>
        <transition name="component-fade" mode="out-in">
          <router-view
            :user="user"
            @updatebc="updateList"
            @loading="loading"
            @success="showSuccessNotis"
            @warning="showWarningNotis"
            @error="showErrorNotis"
            @theme="updateTheme"
            @logoutConform="logoutConform"/>
        </transition>
        <v-row justify="center">
          <v-dialog v-model="comformDialog" persistent max-width="500">
            <v-card>
              <v-card-title class="headline">
                確認
              </v-card-title>
              <v-card-text>
                <h4>保存されていない編集内容は消去されますがよろしいですか？</h4>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn depressed color="grey lighten-1" @click.prevent="exit">キャンセル</v-btn>
                <v-btn depressed color="error" @click.prevent="enter">はい</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
        <v-row justify="center">
          <v-dialog v-model="logoutDialog" persistent max-width="500">
            <v-card>
              <v-card-title class="headline"></v-card-title>
              <v-card-text>
                <h4>ユーザー情報の更新 または ログイン情報が失効しました。<br/>再度ログインしてください。</h4>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn depressed color="primary" @click.prevent="logout"><v-icon>mdi-login-variant</v-icon>ログイン</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </v-container>
    </v-content>
    <global-footer/>
  </v-app>
</template>

<script>
import GlobalHeader from './shared/GlobalHeader';
import GlobalSidebar from './shared/GlobalSidebar';
import GlobalFooter from './shared/GlobalFooter';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { UserStateActions } from "@/store/module/user-state";

export default {
  name: 'Main',
  components: {
    Loading,
    GlobalHeader,
    GlobalSidebar,
    GlobalFooter
  },
  data: () => ({
    user: {},
    drawer: true,
    mini: true,
    notis: false,
    icon: "",
    color: "",
    message: "",
    breadcrumbs: [],
    themes: [
      {id: 0, color: "#0f6eb2"},
      {id: 1, color: "#16a086"},
      {id: 2, color: "#f2a02a"},
    ],
    loader: {
      loading: false,
      type: "dots",
      color: "#1C65FF",
      size: {
        height: 150,
        width: 200
      }
    },
    checkContent: [
      "WorkingBudgetStore",
      "WorkingBudgetEdit",
      // "WorkerDailyReportStore",
      // "WorkerDailyReportEdit",
      "WorkerDailyReportBusinessTripEdit",
      "WorkerDailyReportExpenseEdit",
      "ExpenseTemplateEntry",
      "ExpenseTemplateEdit"
    ],
    comformDialog: false,
    logoutDialog: false,
    toView: null,
    url: null
  }),
  created () {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.updateTheme();
  },
  mounted () { this.updateList(); },
  watch: { '$route' () { this.updateList(); } },
  methods: {
    loading (value) {
      this.loader.loading = value;
    },
    comform (value) {
      if (this.checkContent.includes(this.$route.name)) {
        this.url = value;
        this.toView = null;
        this.comformDialog = true;
      } else {
        this.$router.push({ path: value });
      }
    },
    comformTo (value) {
      if (this.checkContent.includes(this.$route.name)) {
        this.url = null;
        this.toView = value;
        this.comformDialog = true;
      } else {
        this.$router.push(value);
      }
    },
    logoutConform () {
      this.logoutDialog = true;
    },
    logout () {
      this.$store.dispatch(UserStateActions.deleteAuth);
      this.$store.dispatch(UserStateActions.deleteUser);
      this.$router.push({ name: "Login" })
    },
    enter () {
      this.exit();
      if (this.url) {
        this.$router.push({ path: this.url });
      } else {
        this.$router.push(this.toView);
      }
    },
    exit () {
      this.comformDialog = false;
    },
    updateList () {
      this.breadcrumbs = this.$route.meta.breadcrumbs ;
    },
    updateMiniProperty () {
      this.mini = !this.mini;
    },
    showSuccessNotis(message) {
      this.icon = "mdi-check-circle-outline";
      this.color = "success";
      this.message = message;
      this.notis = true;
    },
    showWarningNotis(message) {
      this.icon = "mdi-alert-outline";
      this.color = "warning";
      this.message = message;
      this.notis = true;
    },
    showErrorNotis(message) {
      this.icon = "mdi-close-octagon-outline";
      this.color = "error";
      this.message = message;
      this.notis = true;
    },
    updateTheme(theme_no) {
      if (theme_no == null) {
        theme_no = this.user.theme_no;
      }
      var theme = this.themes.find(v => v.id === theme_no);
      if (theme) {
        this.$vuetify.theme.themes.light.accent = theme.color;
      }
    }
  }
};
window.onkeydown = function(e) {
  if (e.keyCode == 9)
    return false;
};
</script>

<style lang="scss">
.component-fade-enter-active, .component-fade-leave-active {
  transition: opacity .5s ease;
}
.component-fade-enter, .component-fade-leave-to {
  opacity: 0;
}
// table th + th { border-left:1px solid #dddddd; }
// table td + td { border-left:1px solid #dddddd; }
.v-data-table {
  white-space : nowrap;
}
</style>
